import { useEffect, useRef, useState } from "react";
import { withTranslation, Trans } from "react-i18next";

import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import AppCard from "@plannel/components/ui/AppCard";
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';

import BaseConfigModal from "@plannel/components/modal/BaseConfigModal";
import authService from "@plannel/services/system/auth-service";
import userService from "@plannel/services/system/user-service";
import Snackbar from "@plannel/components/Snackbar";
import debug from "@plannel/utils/debug-util";
import ColorUtil from "@plannel/pages/utils/color-util";
import { isEmpty } from "lodash";

const AuthAppSettingModal = ({ t, open, setOpen }) => {
  const currentUser = authService.getCurrentUser();
  const { username } = currentUser;
  const { snackBarMessageColor } = ColorUtil;

  const clickedCount = useRef(0);
  const [msg, setMsg] = useState("");

  const [snackInfo, setSnackInfo] = useState({ open: false, severity: "", content: "" });
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  const getQrCode = () => {
    userService.generateQRUrl(username)
      .then(response => {
        const { data } = response;
        if (isEmpty(data)) {
          setSnackInfo({ open: true, severity: snackBarMessageColor.networkError, content: t("MSG_NetworkError") });
        } else {
          setQrCodeUrl(data);
        }
      })
      .catch(e => {
        setSnackInfo({ open: true, severity: snackBarMessageColor.networkError, content: t("MSG_NetworkError") });
        debug(e);
      });
  }

  const initSettings = () => {
    clickedCount.current = 0;
    setMsg("");
  }

  const handleClose = () => {
    clickedCount.current += 1;
    setMsg("MSG_SaveAuthApp");
    if (clickedCount.current > 1) {
      initSettings();
      setOpen(false);
    }
  }

  useEffect(() => {
    if (open) {
      getQrCode();
    } else {
      setQrCodeUrl("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const Anchor = props => {
    return (
      <a {...props} >{props.children}</a>
    );
  }

  return <>
    {/* 안내 모달이라 확인 버튼 하나뿐이다 — 저장이 아니므로 ok + DoneAll.
        Cancel(과 배경 클릭)도 handleClose 로 간다 — 원래 배경 클릭 동작과 같다. */}
    <BaseConfigModal
      open={open}
      onClose={handleClose}
      title={t("authApp")}
      onSave={handleClose}
      saveLabel={t("ok")}
      saveIcon={<DoneAllIcon />}
      size="lg"
    >
        {/* 여백을 따로 주지 않는다 — 상하좌우 16px 은 셸(DialogContent)이 이미 준다 */}
        <Box>
          <Typography variant="body2" gutterBottom>
            <Trans
              i18nKey="MSG_ScanBarcode"
              components={[
                <Anchor key="android" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" />,
                <Anchor key="ios" href="https://apps.apple.com/us/app/google-authenticator/id388497605" />
              ]}
            />
          </Typography>
          <Box sx={{ my: 2, ml: 1 }}>
            <Typography variant="body2" gutterBottom>
              • <Trans i18nKey="MSG_TapGooglePlusButton" components={[<b key="tap"></b>]} />
            </Typography>
            <Typography variant="body2" gutterBottom>
              • <Trans i18nKey="MSG_ChooseScanQrCode" components={[<b key="choose"></b>]} />
            </Typography>
          </Box>
          <Box className='home-area' sx={{ my: 4 }}>
            <AppCard>
              <CardContent sx={{ display: "inline-flex", width: "180px", height: "180px", alignItems: "center", justifyContent: "center" }}>
                <QrCodeArea qrCodeUrl={qrCodeUrl} />
              </CardContent>
            </AppCard>
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          {Boolean(msg) && (
            <Alert severity="error">{t(msg)}</Alert>
          )}
        </Box>
    </BaseConfigModal>
    <Snackbar
      open={snackInfo.open}
      onClose={() => setSnackInfo({ ...snackInfo, open: false })}
      severity={snackInfo.severity}
      content={snackInfo.content}
    />
  </>
}

const QrCodeArea = ({qrCodeUrl}) => {
  if(isEmpty(qrCodeUrl)) {
    return <CircularProgress />;
  } else {
    return <img id="qrcode" style={{ height: '150px' }} className='home-area' src={qrCodeUrl} alt="QR Code" />
  }
}

export default withTranslation()(AuthAppSettingModal);